interface FormSubmitProps {
  value: string;
  isLoading: boolean;
  isDisabled?: boolean;
  className?: string;
}

export const FormSubmit = ({
  value,
  isLoading,
  isDisabled = false,
  className = ''
}: FormSubmitProps) => {
  const loader = () =>
    isLoading ? (
      <span className="absolute inset-0 flex items-center justify-center">
        <svg
          className="animate-spin h-5 w-5 text-surface-base"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </span>
    ) : null;

  const disabled = isDisabled || isLoading;

  return (
    <button
      type="submit"
      disabled={disabled}
      className={`
        w-[301px] md:w-[392px] h-[52px] relative 
        font-body text-[16px] font-medium text-surface-base
        rounded-[32px] transition-all duration-200 mb-[22px]
        ${
          disabled
            ? 'bg-gray-900 opacity-50 cursor-not-allowed'
            : 'bg-base-black hover:opacity-90 active:opacity-80'
        }
        hover:outline-none hover:shadow-[0_0_0_4px_rgba(93,225,255,0.20)]
        ${className}
      `}
    >
      {loader()}
      <span className={isLoading ? 'invisible' : ''}>{value}</span>
    </button>
  );
};
